module.exports = __webpack_public_path__ + "static/media/7ICJ4.668ac7d1.jpg";